// extracted by mini-css-extract-plugin
module.exports = {"container":"info_container__sORSr","infoContainer":"info_infoContainer__2Y4W5","actionsContainer":"info_actionsContainer__1DuV6"};